/** App path constants (shared by router and components; keep free of screen imports to avoid cycles). */
export const ROUTES = Object.freeze({
  ROOT: '/',
  SIGNIN: '/signin',
  CREATE_ACCOUNT: '/create-account',
  CREATE_NOTETAKER_ACCOUNT: '/create-notetaker-account',
  TROUBLE_LOGGING_IN: '/trouble-logging-in',
  IMPLICIT_CALLBACK: '/callback',
  APP_SWITCHER: '/app-switcher',
  EHR_LAUNCH: '/launch',
  EHR_CALLBACK: '/ehr/callback',
  SUBSCRIPTIONS: '/subscriptions',

  // Route defined by Okta, so not very intuitive
  // /login?recoveryToken=TOKEN   redirects to /signin/recovery/TOKEN
  // /login?activationToken=TOKEN redirects to /signin/recovery/TOKEN
  RESET_PASSWORD_OR_ACTIVATE_ACCOUNT: '/login',
});
